import { Activity as PlanActivity } from '@vaadataworks/vaa-planboard';
import { atom } from 'jotai';
import { JSONSchema7 } from 'json-schema';
export const activities = atom<PlanActivity<any>[]>([]);
export const schema = atom<JSONSchema7>({});
